'use client'

import { MainNavigationListItemContext } from '../MainNavigationItem/MainNavigationListItemContext'
import React, { useContext } from 'react'

export interface SubNavigationListProps {
    children: React.ReactNode
}

/**
 * Visual container for the sub navigation flyout.
 *
 * Renders a positioned wrapper that contains a `<ul>` for sub navigation items. The list
 * visibility is controlled via `hidden={!isOpen}` based on the `MainNavigationItemContext`.
 */
export const SubNavigationList = ({ children }: SubNavigationListProps) => {
    const context = useContext(MainNavigationListItemContext)
    const overlay = context?.overlay
    const isOpen = overlay?.triggerAriaProps['aria-expanded'] ?? false

    return (
        <div
            ref={overlay?.contentRef as React.Ref<HTMLDivElement> | undefined}
            {...overlay?.contentProps}
            className="main-navigation__sub-navigation-wrapper absolute top-full left-1/2 transform -translate-x-1/2"
            hidden={!isOpen}
        >
            <ul className="bg-shade-100 border border-shade-200 shadow-drop-sm mt-[2px] list-none m-0 p-0">
                {children}
            </ul>
        </div>
    )
}
